var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useState } from "react";
import { AonDialog } from "../../components/core/AonDialog";
import { getAONStaffDropData, getAONStaffTypes, handleAONStaffCrud } from "../../api/marketData/AllStaffCrud";
import { UuiFlexlayout, UuiLogo } from "@aonunited/react";
import { AonSelect } from "../../components/core/AonSingleSelect";
import { AonButton } from "../../components/core/AonButton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faClose } from "@fortawesome/free-solid-svg-icons";
import { BUTTON_VARIANT } from "../../components/core/AonButton/consts";
import { useClientPageStore, useErrorStore } from "../../store";
import { useNavigate } from "react-router-dom";
import { AonCustomSearchDropDown } from "../client/clientComponents/CommonFilter/AonCustomSearch";
export var AddAndUpdateAonStaffDialog = function (props) {
    var AddDailogBody = function () {
        var selectedAonStaffAccount = useClientPageStore().selectedAonStaffAccount;
        var typeId = selectedAonStaffAccount ? selectedAonStaffAccount.associatedColleagueTypeId.toString() : "";
        var _a = useState([]), allDropDownOptions = _a[0], setAllDropDownOptions = _a[1];
        var _b = useState(null), dropDownValue = _b[0], setDropDownValue = _b[1];
        var _c = useState(), searchValue = _c[0], setSearchValue = _c[1];
        var _d = useState(typeId), allTypeValue = _d[0], setAllTypeValue = _d[1];
        var _e = useState([]), allTypeOptions = _e[0], setAllTypeOptions = _e[1];
        var _f = useState(""), errorMsg = _f[0], setErrorMsg = _f[1];
        var _g = useState(false), apiLoading = _g[0], setApiLoading = _g[1];
        var _h = useState(null), debounceTimer = _h[0], setDebounceTImer = _h[1];
        var navigation = useNavigate();
        var errorStore = useErrorStore();
        useEffect(function () {
            var inputRef = document.getElementById("__AddSearchId__");
            if (inputRef) {
                inputRef.addEventListener("keydown", function (Event) {
                    if (Event.key === "Enter") {
                        fetchAllSearchdata(Event === null || Event === void 0 ? void 0 : Event.target);
                        Event === null || Event === void 0 ? void 0 : Event.preventDefault();
                    }
                });
            }
            fetchAlltype();
        }, []);
        var fetchAllSearchdata = function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (_searchValue) {
                var value, res, options, error_1;
                if (_searchValue === void 0) { _searchValue = ""; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            value = _searchValue ? _searchValue : searchValue;
                            if (!value) {
                                return [2 /*return*/];
                            }
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            setApiLoading(true);
                            return [4 /*yield*/, getAONStaffDropData(value)];
                        case 2:
                            res = _a.sent();
                            options = res.data.map(function (item) { return (__assign({ label: item.displayName, value: item.id }, item)); });
                            setAllDropDownOptions(options);
                            return [3 /*break*/, 5];
                        case 3:
                            error_1 = _a.sent();
                            console.log(error_1);
                            errorStore.showError({ message: "Error", code: "500" });
                            navigation('/error');
                            return [3 /*break*/, 5];
                        case 4:
                            setApiLoading(false);
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        };
        var resetValues = function () {
            setAllTypeValue("");
            setSearchValue("");
            setDropDownValue("");
            setAllDropDownOptions([]);
        };
        var fetchAlltype = function () { return __awaiter(void 0, void 0, void 0, function () {
            var res, options, error_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, getAONStaffTypes()];
                    case 1:
                        res = _a.sent();
                        options = res.data.map(function (item) { return ({
                            label: item.description,
                            value: item.id.toString(),
                        }); });
                        setAllTypeOptions(options);
                        return [3 /*break*/, 3];
                    case 2:
                        error_2 = _a.sent();
                        console.log(error_2);
                        handledErrorMsg("Something went wrong, Please try again");
                        errorStore.showError({ message: "Error", code: "500" });
                        navigation('/error');
                        return [3 /*break*/, 3];
                    case 3: return [2 /*return*/];
                }
            });
        }); };
        var onClickAdd = function () {
            var args_1 = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args_1[_i] = arguments[_i];
            }
            return __awaiter(void 0, __spreadArray([], args_1, true), void 0, function (isUpdate) {
                var findSelected, err_1;
                if (isUpdate === void 0) { isUpdate = false; }
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 6, , 7]);
                            if (!isUpdate) return [3 /*break*/, 3];
                            if (!selectedAonStaffAccount) return [3 /*break*/, 2];
                            return [4 /*yield*/, handleAONStaffCrud([{
                                        "clientGuid": props.clientGuid,
                                        "accountGuid": selectedAonStaffAccount === null || selectedAonStaffAccount === void 0 ? void 0 : selectedAonStaffAccount.accountGuid,
                                        "associateColleagueTypeId": allTypeValue ? Number(allTypeValue) : NaN,
                                        "changeComment": "Changed by colleague in MarketPreView",
                                        "addColleague": {
                                            "email": selectedAonStaffAccount === null || selectedAonStaffAccount === void 0 ? void 0 : selectedAonStaffAccount.colleagueEmail,
                                            "displayName": selectedAonStaffAccount === null || selectedAonStaffAccount === void 0 ? void 0 : selectedAonStaffAccount.colleagueDisplayName,
                                            "identityProviderID": 2,
                                            "idFromProvider": selectedAonStaffAccount === null || selectedAonStaffAccount === void 0 ? void 0 : selectedAonStaffAccount.clientAssociatedColleagueGuid,
                                        },
                                        "addDeleteUpdate": 3
                                    }])];
                        case 1:
                            _a.sent();
                            _a.label = 2;
                        case 2: return [3 /*break*/, 5];
                        case 3:
                            findSelected = allDropDownOptions.find(function (item) { return item.id === dropDownValue; });
                            return [4 /*yield*/, handleAONStaffCrud([{
                                        "clientGuid": props.clientGuid,
                                        "associateColleagueTypeId": allTypeValue ? Number(allTypeValue) : NaN,
                                        "changeComment": "Changed by colleague in MarketPreView",
                                        "addColleague": {
                                            "email": findSelected === null || findSelected === void 0 ? void 0 : findSelected.email,
                                            "displayName": findSelected === null || findSelected === void 0 ? void 0 : findSelected.displayName,
                                            "identityProviderID": 2,
                                            "idFromProvider": findSelected === null || findSelected === void 0 ? void 0 : findSelected.id,
                                        },
                                        "addDeleteUpdate": 1
                                    }])];
                        case 4:
                            _a.sent();
                            _a.label = 5;
                        case 5:
                            props.refressPage();
                            return [3 /*break*/, 7];
                        case 6:
                            err_1 = _a.sent();
                            console.log(err_1);
                            errorStore.showError({ message: "Error", code: "500" });
                            navigation('/error');
                            return [3 /*break*/, 7];
                        case 7: return [2 /*return*/];
                    }
                });
            });
        };
        var handledErrorMsg = function (msg) {
            setErrorMsg(msg);
            var timoutInstance = setTimeout(function () {
                setErrorMsg("");
                clearTimeout(timoutInstance);
            }, 3000);
        };
        var debounce = function (func, timer) {
            return function (text, isEnterClicked) {
                if (isEnterClicked === void 0) { isEnterClicked = false; }
                if (!text) {
                    setAllDropDownOptions([]);
                    setSearchValue("");
                }
                setSearchValue(text);
                clearTimeout(debounceTimer);
                setDebounceTImer(setTimeout(function () {
                    if (text.length > 1) {
                        func(text);
                    }
                }, timer));
            };
        };
        var InputDebounce = debounce(fetchAllSearchdata, 300);
        return React.createElement("div", null,
            selectedAonStaffAccount ?
                React.createElement("div", { style: { width: "100%" } },
                    React.createElement("h3", { style: { marginTop: "0px", marginBottom: "8px" } }, "Update Aon Staff"))
                : React.createElement("div", { style: { width: "100%" } },
                    React.createElement("h3", null, "Add New Aon Staff"),
                    React.createElement(UuiFlexlayout, { alignItems: "center", direction: 'row', gap: 'xs' },
                        React.createElement("div", { style: { display: "flex", flexDirection: "column" } },
                            React.createElement("span", { style: { paddingBottom: "10px" } },
                                "Name:",
                                React.createElement("span", { style: { color: "red" } }, "*")),
                            React.createElement("div", { style: { width: "340px" } },
                                React.createElement(AonCustomSearchDropDown, { searchValue: searchValue || "", handleText: InputDebounce, allOptions: __spreadArray([], allDropDownOptions.map(function (item) { return ({ lable: item.label, value: item.value, }); }), true), fetching: apiLoading, onSelectOption: function (value) {
                                        setDropDownValue(value);
                                        var findId = allDropDownOptions.find(function (item) { return item.id === value; });
                                        setSearchValue(findId.label);
                                    } }))),
                        React.createElement(AonButton, { style: { marginLeft: "10px", marginTop: "20px" }, disabled: !dropDownValue, variant: BUTTON_VARIANT.DEFAULT, onClick: function () {
                                resetValues();
                            } }, "Reset"))),
            React.createElement("div", { style: { marginTop: "20px", width: "340px" } },
                React.createElement(UuiFlexlayout, { style: {}, direction: 'row', gap: 'xs' },
                    React.createElement(AonSelect, { style: { width: "100%" }, label: "Type", required: true, defaultValue: 'Select access level', selectedValue: allTypeValue !== null && allTypeValue !== void 0 ? allTypeValue : "", handelChecked: function (event) {
                            setAllTypeValue(event.target.selectedValue);
                        }, options: allTypeOptions }))),
            React.createElement("div", { style: { marginBlock: "10px", marginBottom: "-28px", display: "flex" } },
                selectedAonStaffAccount ? React.createElement(AonButton, { style: { marginRight: "8px" }, disabled: !allTypeValue, variant: BUTTON_VARIANT.DEFAULT, onClick: function () {
                        onClickAdd(true);
                    } }, "Submit")
                    : React.createElement(AonButton, { disabled: !dropDownValue || !allTypeValue, style: { marginRight: "8px" }, variant: BUTTON_VARIANT.DEFAULT, onClick: function () {
                            onClickAdd();
                        } }, "Submit"),
                React.createElement(AonButton, { variant: BUTTON_VARIANT.PROMINENT, style: { marginRight: "8px" }, onClick: function () {
                        props.onClickClose();
                    } }, "Cancel")),
            React.createElement("div", { style: { fontSize: "18", color: "red", marginBlock: "18" } }, errorMsg ? React.createElement("span", null, errorMsg) : null));
    };
    return React.createElement(AonDialog, { dismissOnEsc: false, dismissOnOverlay: false, opened: props.addDailog, enableBackgroundScroll: false, header: React.createElement("div", { className: 'header' },
            React.createElement("div", { className: 'logo_about_dialog' },
                React.createElement(UuiLogo, { onClick: function () { } })),
            React.createElement(FontAwesomeIcon, { className: 'text-icon', onClick: props.onClickClose, icon: faClose })), body: React.createElement(AddDailogBody, null) });
};
